import { getThanksParams } from '../html/getThanksParams.js'

/**
 * Get user ID with priority: lead_id -> analytics_id -> session_id
 * @returns {{id: string, type: 'lead_id'|'analytics_id'|'session_id'}}
 */
export function getUserId() {
  const thanksParams = getThanksParams()

  // 1. Lead ID (highest priority)
  if (thanksParams.sub1 && thanksParams.sub1.trim() !== '') {
    return {
      id: `lead_${thanksParams.sub1.trim()}`,
      type: 'lead_id',
    }
  }

  // 2. Analytics ID from localStorage
  let analyticsId = localStorage.getItem('analytics_user_id')
  if (analyticsId) {
    return {
      id: analyticsId,
      type: 'analytics_id',
    }
  }

  // 3. Create new analytics ID
  analyticsId = `analytics_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
  localStorage.setItem('analytics_user_id', analyticsId)

  return {
    id: analyticsId,
    type: 'analytics_id',
  }
}
